const permissions = {
  securityApp: {
    read: 'graylog_security:read',
  },
};

export default permissions;
